/* Menú nuevo (A · B · C), 3-nov-2026. Lo carga sections/header.liquid.
   1. ?menu=a|b|c|hoy elige qué menú se ve cuando el header carga los cuatro («comparar», ajustes avanzados).
      Se guarda en sessionStorage, así se mantiene al navegar por la vista previa.
   2. «Lo último que miraste» (menú A): guarda en localStorage los productos vistos (sin cuenta) y los pinta.
   3. Mega menú C: la foto grande cambia al pasar el ratón (o el foco) por cada colección. */
(function () {
  var KEY = 'fh_menu', SEEN = 'fh_vistos';

  // 1 · versión
  try {
    var q = new URLSearchParams(location.search).get('menu');
    if (q && /^(a|b|c|hoy)$/.test(q)) sessionStorage.setItem(KEY, q);
    var v = sessionStorage.getItem(KEY);
    if (v && document.querySelector('[data-fhm-v="' + v + '"]')) {
      document.querySelectorAll('[data-fhm-v]').forEach(function (el) {
        el.classList.toggle('is-on', el.getAttribute('data-fhm-v') === v);
      });
    }
  } catch (e) {}

  // 2 · vistos
  var list = [];
  try { list = JSON.parse(localStorage.getItem(SEEN) || '[]') || []; } catch (e) { list = []; }
  var now = document.querySelector('script[data-fhm-now]');
  var cur = null;
  if (now) {
    try {
      cur = JSON.parse(now.textContent);
      if (cur && cur.u && cur.i) {
        list = list.filter(function (p) { return p.h !== cur.h; });
        list.unshift({ u: cur.u, t: cur.t, i: cur.i, h: cur.h });
        list = list.slice(0, 8);
        localStorage.setItem(SEEN, JSON.stringify(list));
      }
    } catch (e) {}
  }
  var show = list.filter(function (p) { return p && /^\/[^\/]/.test(p.u || '') && /^(https:)?\/\//.test(p.i || '') && (!cur || p.h !== cur.h); }).slice(0, 3);
  if (show.length) {
    document.querySelectorAll('[data-fhm-seen]').forEach(function (box) {
      var ul = box.querySelector('[data-fhm-seen-list]');
      if (!ul) return;
      while (ul.firstChild) ul.removeChild(ul.firstChild);
      show.forEach(function (p) {
        var a = document.createElement('a'); a.href = p.u;
        var img = document.createElement('img'); img.src = p.i; img.alt = ''; img.loading = 'lazy'; img.width = 100; img.height = 100;
        var s = document.createElement('span'); s.textContent = p.t;
        a.appendChild(img); a.appendChild(s); ul.appendChild(a);
      });
      box.hidden = false;
    });
  }

  // 3 · mega C: foto que cambia
  document.querySelectorAll('[data-fhm-hover]').forEach(function (root) {
    var items = root.querySelectorAll('[data-fhm-hov]'), imgs = root.querySelectorAll('[data-fhm-stage]');
    function set(n) {
      items.forEach(function (it) { it.classList.toggle('is-on', it.getAttribute('data-fhm-hov') === n); });
      imgs.forEach(function (im) { im.classList.toggle('is-on', im.getAttribute('data-fhm-stage') === n); });
    }
    items.forEach(function (it) {
      var n = it.getAttribute('data-fhm-hov');
      it.addEventListener('mouseenter', function () { set(n); });
      it.addEventListener('focus', function () { set(n); });
    });
  });
})();
